export default "__VITE_ASSET__C2B9mSOp__"